import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { tap, map } from 'rxjs/operators';
import {Router} from '@angular/router';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class OvhMonitService {
  nickhandles: any;

  constructor(
    private readonly http: HttpClient,
  	private readonly router: Router) 
  { }
  
  handleError(error) {
  	console.log("handleError", error);
  	if (error.url.indexOf('/login') !== -1) {
  		console.log("redirecting to login page");
  		window.location.replace('/login');
  	}
  }
  
  getInstanceSystem(nickhandleCode : string, projectId : string, instanceId : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/' + projectId + '/' + instanceId + '/system');
  }
  
  getSystemStatus(nickhandleCode : string, filter : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/system-status?filter=' + filter );
  }

  getDiskStatus(nickhandleCode : string, filter : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/disk-status?filter=' + filter );
  }
  
  getInstanceDisk(nickhandleCode : string, projectId : string, instanceId : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/' + projectId + '/' + instanceId + '/disks');
  }
  
  getDnsStatus(nickhandleCode : string, filter : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/dns-status?filter=' + filter );
  }
  
  getInstanceDns(nickhandleCode : string, projectId : string, instanceId : string) : any {
	return this.http.get('/api/ovh/nickhandle/' + nickhandleCode + '/' + projectId + '/' + instanceId + '/dns');
  }

}
